// extracted by mini-css-extract-plugin
export default {"pictureArea":"MiniProfile_pictureArea__PiNjs","picture":"MiniProfile_picture__BwIQf","sideItems":"MiniProfile_sideItems__LEiPa","icon":"MiniProfile_icon__-OVOq"};